import { render } from "../income_predictor/income_predictor.html?vue&type=template&id=b1bf399e&external"
import script from "../income_predictor/income_predictor.js?vue&type=script&lang=js&external"
export * from "../income_predictor/income_predictor.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__